export const generateUniqLocalKey = (tableId?: string, viewId?: string) => `${tableId}-${viewId}`;
